import cn from "classnames";
import { TAppearance } from "@/shared/ui/types";

interface ILoaderProps {
  fullPage?: boolean;
  className?: string;
  appearance?: TAppearance | "default";
}

const loaderAppearanceClassName = {
  default: "border-primary",
  primary: "border-[#f5f5f5]",
  secondary: "border-eerie-black",
  danger: "border-white",
  brand: "border-white",
};

export const Loader = ({ fullPage = false, className, appearance = "default" }: ILoaderProps) => {
  return (
    <div className={cn("flex items-center justify-center", fullPage && "fixed inset-0")}>
      <div
        className={cn(
          "box-border inline-block h-12 w-12 animate-spin self-center rounded-full border-t-[3px] border-r-[3px] border-r-transparent",
          loaderAppearanceClassName[appearance],
          className,
        )}
      />
    </div>
  );
};
